module.exports = __webpack_public_path__ + "img/vegetable-artichokes-350x184.8c911247.jpg";